/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const Pax: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 28 28" size={size} color={color} {...props}>
      <g fillRule="evenodd">
        <path d="M3 25v-1.547c.143-1.005 1.25-1.945 2.741-2.62a9.304 9.304 0 001.12-.595c1.687-1.06 3.357-1.759 5.044-2.116-.321-.358-.617-.822-.901-1.363a28.372 28.372 0 01-.978-2.276c-.09-.198-.155-.477-.219-.835-.04-.171-.063-.463-.063-.872v-.994c0-.517-.013-.978-.053-1.414-.013-.065-.013-.185-.013-.384 0-.94.272-1.773.799-2.488.527-.729 1.236-1.178 2.124-1.363.373-.092.835-.133 1.365-.133 2.263 0 3.654 1.005 4.181 3.016.064.33.103.661.103.991 0 .185 0 .303-.013.358-.026.541-.04 1.005-.04 1.413v.994c0 .385-.013.662-.052.845-.09.423-.167.716-.232.859-.707 1.772-1.34 2.991-1.906 3.639 1.3.252 2.535.688 3.718 1.322.5.28.964.542 1.388.795.411.252.786.45 1.12.596 1.146.514 1.942 1.11 2.393 1.785.193.33.321.61.374.835v1.547H3V25z" />
      </g>
    </Icon>
  );
};

export default Pax;

Pax.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
